import LoginPage from "../views/Pages/LoginPage.jsx";
import LoginKioskPage from "../views/Pages/LoginKioskPage.jsx";
import RegisterPage from "../views/Pages/RegisterPage.jsx";
import PricingPage from "../views/Pages/PricingPage.jsx";
import LockScreenPage from "../views/Pages/LockScreenPage.jsx";
import UnderConstructionPage from "../views/Pages/UnderConstructionPage.jsx";

var pagesRoutes = [
  {
    path: "/pages/login-page",
    name: "Login Page",
    mini: "LP",
    component: LoginPage
  },
  {
    path: "/pages/login-kiosk-page",
    name: "Login Kiosk Page",
    mini: "LP",
    component: LoginKioskPage
  },
  {
    path: "/pages/pricing-page",
    name: "Pricing",
    mini: "PR",
    //Switch this to place the registration to Under Construction
    //component: UnderConstructionPage
    component: PricingPage
  },
  {
    path: "/pages/register-page",
    name: "Register",
    mini: "RP",
    //Switch this to place the registration to Under Construction
    component: UnderConstructionPage
    //component: RegisterPage
  },

    /*
  {
    path: "/pages/lock-screen-page",
    name: "Lock Screen Page",
    mini: "LSP",
    component: LockScreenPage
  },*/
  {
    path: "/pages/under-construction-page",
    name: "Under Construction Page",
    mini: "UCP",
    component: UnderConstructionPage
  }
];

export default pagesRoutes;



// WEBPACK FOOTER //
// ./src/routes/pages.jsx